<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { inquiryCurrencyConfig, saveOrUpdateCurrencyConfig, deleteCurrencyConfig, setStandardCurrency } from '../../../../../api/home.js';
export default {
	name: 'CurrencySettings',
	data() {
		return {
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('CurrencySettingsheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('CurrencySettingsoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			/* 表格 */
			// 弹框
			popup: false,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			Count: 0
		};
	},
	created() {
		this.searrchForData();
	},
	mounted() {},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('CurrencySettingsoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('CurrencySettingsheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},

		selectionchange(e) {
			this.Count = e.length;
		},
		//设置本位币
		sezbwb() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择要设置的数据');
			} else if (this.$refs.tablebox.getSelectionval().length > 1) {
				this.$message.error('只能设置一条数据');
			} else {
				this.$showConfirm({
					message: '确认设置?'
				}).then(res => {
					if (res == 'confirm') {
						let params = {
							id: this.$refs.tablebox.getSelectionval()[0].id
						};
						setStandardCurrency(params).then(res => {
							if (res.data.code == '200') {
								this.searrchForData();
								this.$message.success('设置成功');
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			}
		},
		//删除
		deletebz() {
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				this.$message.error('请选择要删除的数据');
			} else {
				this.$showConfirm({
					message: '确认删除?'
				}).then(res => {
					if (res == 'confirm') {
						let params = {
							ids: this.$refs.tablebox
								.getSelectionval()
								.map(v => v.id)
								.join(',')
						};
						deleteCurrencyConfig(params).then(res => {
							if (res.data.code == '200') {
								this.searrchForData();
								this.$message.success('删除成功');
							} else {
								this.$message.error(res.data.message);
							}
						});
					}
				});
			}
		},
		//保存
		popupbc() {
			this.$refs.taxform.submitForm();
		},
		getdata(e) {
			let params = {};
			params.config = JSON.stringify(this.formdata);
			saveOrUpdateCurrencyConfig(params).then(res => {
				if (res.data.code == '200') {
					this.popup = false;
					this.searrchForData();
					this.$message.success('保存成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		popuptk(k) {
			if (k != 0) {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择要修改的数据');
				} else if (this.$refs.tablebox.getSelectionval().length > 1) {
					this.$message.error('只能修改一条数据');
				} else {
					this.formdata.id = this.$refs.tablebox.getSelectionval()[0].id;
					this.formdata.currency = this.$refs.tablebox.getSelectionval()[0].currency;
					this.formdata.currencyDesc = this.$refs.tablebox.getSelectionval()[0].currencyDesc;
					this.popup = true;
				}
			} else {
				this.formdata.id = '';
				this.formdata.currency = '';
				this.formdata.currencyDesc = '';
				this.popup = true;
			}
			this.$nextTick(() => {
				this.$refs['taxform'].clearValidate();
			});
		},
		searrchForData() {
			let json = {};
			let params = {};
			params.criteriaJson = JSON.stringify(json);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = "standardCurrency";
			params.order = "desc";
			inquiryCurrencyConfig(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
